"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSyncBuildingAreasFromDTMutation = exports.useDeleteBuildingAreaChangeEventMutation = exports.useFetchBuildingAreaAuditLogQuery = exports.useFetchBuildingAreaHistoryQuery = exports.useUpdateBuildingAreaMutation = exports.useDeleteBuildingAreaMutation = exports.useFetchBuildingAreaQuery = exports.useFetchAllClientBuildingAreasQuery = exports.useFetchBuildingAreasByBuildingQuery = exports.useSearchBuildingAreasQuery = exports.useCreateBuildingAreaMutation = exports.buildingAreaApi = void 0;
// api/buildingAreaApi.ts
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.buildingAreaApi = (0, react_1.createApi)({
    reducerPath: "buildingAreaApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["building_areas"],
    endpoints: function (builder) { return ({
        createBuildingArea: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/building-area/create",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["building_areas"],
        }),
        searchBuildingAreas: builder.query({
            // Cache key excludes page/limit when no specific building is selected, since pagination
            // happens client-side on the aggregated list. This prevents the multi-building fan-out
            // from re-running every time the user changes the page or rows-per-page.
            serializeQueryArgs: function (_a) {
                var queryArgs = _a.queryArgs, endpointName = _a.endpointName;
                if (queryArgs.buildingId) {
                    // Server-side pagination — page/limit must be part of the cache key
                    return "".concat(endpointName, "-").concat(JSON.stringify(queryArgs));
                }
                // Client-side pagination — exclude page/limit from the cache key
                var _page = queryArgs.page, _limit = queryArgs.limit, rest = __rest(queryArgs, ["page", "limit"]);
                return "".concat(endpointName, "-").concat(JSON.stringify(rest));
            },
            queryFn: function (arg, _queryApi, _extraOptions, fetchWithBQ) {
                return __awaiter(this, void 0, void 0, function () {
                    var searchParams, result, buildingsResult, buildingsData, buildings, allAreas, _i, buildings_1, building, areasResult, areasData;
                    var _a, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                searchParams = {
                                    clientId: arg.clientId,
                                };
                                if (arg.search)
                                    searchParams.search = arg.search;
                                if (arg.areaNumber)
                                    searchParams.areaNumber = arg.areaNumber;
                                if (arg.areaType)
                                    searchParams.areaType = arg.areaType;
                                if (arg.areaPhysicality)
                                    searchParams.areaPhysicality = arg.areaPhysicality;
                                if (arg.isLeaseable !== undefined)
                                    searchParams.isLeaseable = arg.isLeaseable;
                                if (arg.isPublic !== undefined)
                                    searchParams.isPublic = arg.isPublic;
                                if (arg.isServiceArea !== undefined)
                                    searchParams.isServiceArea = arg.isServiceArea;
                                if (arg.isActive !== undefined)
                                    searchParams.isActive = arg.isActive;
                                if (arg.areaCategory)
                                    searchParams.areaCategory = arg.areaCategory;
                                if (!arg.buildingId) return [3 /*break*/, 2];
                                return [4 /*yield*/, fetchWithBQ({
                                        url: "/v1/building-area/all",
                                        method: "GET",
                                        params: __assign(__assign({}, searchParams), { buildingId: arg.buildingId, page: arg.page || 1, limit: arg.limit || 10 }),
                                    })];
                            case 1:
                                result = _c.sent();
                                if (result.error)
                                    return [2 /*return*/, { error: result.error }];
                                return [2 /*return*/, { data: result.data }];
                            case 2: return [4 /*yield*/, fetchWithBQ({
                                    url: "/v1/building/all",
                                    method: "GET",
                                    params: { clientId: arg.clientId, page: 1, limit: 100 },
                                })];
                            case 3:
                                buildingsResult = _c.sent();
                                if (buildingsResult.error)
                                    return [2 /*return*/, { error: buildingsResult.error }];
                                buildingsData = buildingsResult.data;
                                buildings = ((_a = buildingsData === null || buildingsData === void 0 ? void 0 : buildingsData.content) === null || _a === void 0 ? void 0 : _a.buildings) || [];
                                allAreas = [];
                                _i = 0, buildings_1 = buildings;
                                _c.label = 4;
                            case 4:
                                if (!(_i < buildings_1.length)) return [3 /*break*/, 7];
                                building = buildings_1[_i];
                                return [4 /*yield*/, fetchWithBQ({
                                        url: "/v1/building-area/all",
                                        method: "GET",
                                        params: __assign(__assign({}, searchParams), { buildingId: building._id, page: 1, limit: 1000 }),
                                    })];
                            case 5:
                                areasResult = _c.sent();
                                if (!areasResult.error) {
                                    areasData = areasResult.data;
                                    if ((_b = areasData === null || areasData === void 0 ? void 0 : areasData.content) === null || _b === void 0 ? void 0 : _b.buildingAreas) {
                                        allAreas.push.apply(allAreas, areasData.content.buildingAreas);
                                    }
                                }
                                _c.label = 6;
                            case 6:
                                _i++;
                                return [3 /*break*/, 4];
                            case 7: 
                            // Return the FULL aggregated list. The component handles client-side slicing
                            // based on its local page/rowsPerPage state, so we don't have to refetch on pagination.
                            return [2 /*return*/, {
                                    data: {
                                        success: true,
                                        message: "Building areas retrieved successfully",
                                        content: {
                                            buildingAreas: allAreas,
                                            pagination: { total: allAreas.length, page: 1, limit: allAreas.length },
                                        },
                                    },
                                }];
                        }
                    });
                });
            },
            providesTags: ["building_areas"],
        }),
        fetchBuildingAreasByBuilding: builder.query({
            query: function (obj) { return ({
                url: "/v1/building-area/all",
                method: "GET",
                params: {
                    clientId: obj.clientId,
                    buildingId: obj.buildingId,
                    page: obj.page,
                    limit: obj.limit,
                },
            }); },
            providesTags: ["building_areas"],
        }),
        fetchAllClientBuildingAreas: builder.query({
            queryFn: function (arg, _queryApi, _extraOptions, fetchWithBQ) {
                return __awaiter(this, void 0, void 0, function () {
                    var buildingsResult, buildingsData, buildings, allAreas, _i, buildings_2, building, areasResult, areasData;
                    var _a, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0: return [4 /*yield*/, fetchWithBQ({
                                    url: "/v1/building/all",
                                    method: "GET",
                                    params: { clientId: arg.clientId, page: 1, limit: 100 },
                                })];
                            case 1:
                                buildingsResult = _c.sent();
                                if (buildingsResult.error) {
                                    return [2 /*return*/, { error: buildingsResult.error }];
                                }
                                buildingsData = buildingsResult.data;
                                buildings = ((_a = buildingsData === null || buildingsData === void 0 ? void 0 : buildingsData.content) === null || _a === void 0 ? void 0 : _a.buildings) || [];
                                allAreas = [];
                                _i = 0, buildings_2 = buildings;
                                _c.label = 2;
                            case 2:
                                if (!(_i < buildings_2.length)) return [3 /*break*/, 5];
                                building = buildings_2[_i];
                                return [4 /*yield*/, fetchWithBQ({
                                        url: "/v1/building-area/all",
                                        method: "GET",
                                        params: { clientId: arg.clientId, buildingId: building._id, page: 1, limit: 1000 },
                                    })];
                            case 3:
                                areasResult = _c.sent();
                                if (!areasResult.error) {
                                    areasData = areasResult.data;
                                    if ((_b = areasData === null || areasData === void 0 ? void 0 : areasData.content) === null || _b === void 0 ? void 0 : _b.buildingAreas) {
                                        allAreas.push.apply(allAreas, areasData.content.buildingAreas);
                                    }
                                }
                                _c.label = 4;
                            case 4:
                                _i++;
                                return [3 /*break*/, 2];
                            case 5: return [2 /*return*/, {
                                    data: {
                                        success: true,
                                        message: "Building areas retrieved successfully",
                                        content: {
                                            buildingAreas: allAreas,
                                            pagination: { total: allAreas.length, page: 1, limit: allAreas.length },
                                        },
                                    },
                                }];
                        }
                    });
                });
            },
            providesTags: ["building_areas"],
        }),
        fetchBuildingArea: builder.query({
            query: function (buildingAreaId) { return ({
                url: "/v1/building-area/fetch",
                method: "GET",
                params: {
                    _id: buildingAreaId,
                },
            }); },
            providesTags: ["building_areas"],
        }),
        deleteBuildingArea: builder.mutation({
            query: function (_a) {
                var buildingAreaId = _a.buildingAreaId, performedBy = _a.performedBy, reason = _a.reason;
                return ({
                    url: "/v1/building-area/remove",
                    method: "DELETE",
                    params: __assign({ _id: buildingAreaId, performedBy: performedBy }, (reason ? { reason: reason } : {})),
                });
            },
            invalidatesTags: ["building_areas"],
        }),
        updateBuildingArea: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/building-area/update",
                method: "PUT",
                body: obj,
            }); },
            invalidatesTags: ["building_areas"],
        }),
        fetchBuildingAreaHistory: builder.query({
            query: function (buildingAreaId) { return ({
                url: "/v1/building-area/history",
                method: "GET",
                params: { _id: buildingAreaId },
            }); },
            providesTags: function (_result, _err, areaId) { return [{ type: "building_areas", id: "history:".concat(areaId) }]; },
        }),
        fetchBuildingAreaAuditLog: builder.query({
            query: function (_a) {
                var buildingAreaId = _a.buildingAreaId, action = _a.action, includeDeleted = _a.includeDeleted;
                return ({
                    url: "/v1/building-area/audit-log",
                    method: "GET",
                    params: __assign(__assign({ _id: buildingAreaId }, (action ? { action: action } : {})), (includeDeleted ? { includeDeleted: true } : {})),
                });
            },
            providesTags: function (_result, _err, arg) { return [{ type: "building_areas", id: "audit:".concat(arg.buildingAreaId) }]; },
        }),
        deleteBuildingAreaChangeEvent: builder.mutation({
            query: function (_a) {
                var eventId = _a.eventId, performedBy = _a.performedBy, reason = _a.reason;
                return ({
                    url: "/v1/building-area/audit-log/event",
                    method: "DELETE",
                    body: { eventId: eventId, performedBy: performedBy, reason: reason },
                });
            },
            invalidatesTags: function (_result, _err, arg) { return [
                { type: "building_areas", id: "audit:".concat(arg.buildingAreaId) },
                { type: "building_areas", id: "history:".concat(arg.buildingAreaId) },
            ]; },
        }),
        syncBuildingAreasFromDT: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/building-area/sync-digital-twin",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["building_areas"],
        }),
    }); },
});
exports.useCreateBuildingAreaMutation = exports.buildingAreaApi.useCreateBuildingAreaMutation, exports.useSearchBuildingAreasQuery = exports.buildingAreaApi.useSearchBuildingAreasQuery, exports.useFetchBuildingAreasByBuildingQuery = exports.buildingAreaApi.useFetchBuildingAreasByBuildingQuery, exports.useFetchAllClientBuildingAreasQuery = exports.buildingAreaApi.useFetchAllClientBuildingAreasQuery, exports.useFetchBuildingAreaQuery = exports.buildingAreaApi.useFetchBuildingAreaQuery, exports.useDeleteBuildingAreaMutation = exports.buildingAreaApi.useDeleteBuildingAreaMutation, exports.useUpdateBuildingAreaMutation = exports.buildingAreaApi.useUpdateBuildingAreaMutation, exports.useFetchBuildingAreaHistoryQuery = exports.buildingAreaApi.useFetchBuildingAreaHistoryQuery, exports.useFetchBuildingAreaAuditLogQuery = exports.buildingAreaApi.useFetchBuildingAreaAuditLogQuery, exports.useDeleteBuildingAreaChangeEventMutation = exports.buildingAreaApi.useDeleteBuildingAreaChangeEventMutation, exports.useSyncBuildingAreasFromDTMutation = exports.buildingAreaApi.useSyncBuildingAreasFromDTMutation;
